"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Unlocked_exports = {};
__export(Unlocked_exports, {
  default: () => Unlocked_default
});
module.exports = __toCommonJS(Unlocked_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6602 2.75C15.5456 2.75 16.3073 3.03646 16.9453 3.60938C17.5833 4.18229 17.9349 4.88542 18 5.71875V5.93359V8.47266H16.6719V5.93359C16.6719 5.39974 16.4766 4.95052 16.0859 4.58594C15.6953 4.20833 15.2201 4.01953 14.6602 4.01953C14.1393 4.01953 13.6901 4.1888 13.3125 4.52734C12.9349 4.85286 12.7201 5.25651 12.668 5.73828V5.93359V8.58984H13.4102C13.7617 8.58984 14.0547 8.70703 14.2891 8.94141C14.5365 9.16276 14.6602 9.44271 14.6602 9.78125V15.7188C14.6602 16.0573 14.5365 16.3438 14.2891 16.5781C14.0547 16.7995 13.7617 16.9102 13.4102 16.9102H5.91016C5.57161 16.9102 5.27865 16.7995 5.03125 16.5781C4.78385 16.3438 4.66016 16.0573 4.66016 15.7188V9.78125C4.66016 9.44271 4.78385 9.16276 5.03125 8.94141C5.27865 8.70703 5.57161 8.58984 5.91016 8.58984H11.3398V5.93359C11.3398 5.04818 11.6654 4.29948 12.3164 3.6875C12.9674 3.0625 13.7487 2.75 14.6602 2.75ZM13.4102 9.78125H5.91016V15.7188H13.4102V9.78125Z",
      fill: "currentColor"
    }
  )
);
const SvgUnlocked = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Unlocked_default = SvgUnlocked;
